import { AppSettingsComponent } from "../admin/app-settings/app-settings.component";
import { DcoAdminComponent } from "../admin/dco-admin/dco-admin.component";
import { ListAdminComponent } from "../admin/list-admin/list-admin.component";
import { UserAdminComponent } from "../admin/user-admin/user-admin.component";
import { DcoReferralsComponent } from "../dco-referrals/dco-referrals.component";
import { DentalReferralFormComponent } from "../dental-referral-form/dental-referral-form.component";
import { ResolutionCenterComponent } from "../resolution-center/resolution-center.component";

export interface RouteMeta {
  route: string;
  text: string;
  icon: string;
  roles: string[];
  category: 'main' | 'admin';
  component: any;
  title?: string;
}

export const ROUTE_META: RouteMeta[] = [
  {
    route: '/referrals',
    text: 'Referrals',
    icon: '<i class="fa-sharp-duotone fa-solid fa-file-pen"></i>',
    roles: ['SuperAdmin', 'SystemAdmin', 'DCOUser'],
    category: 'main',
    component: DcoReferralsComponent,
    title: 'CareOregon - DCO Referrals'
  },
  {
    route: '/resolutionCenter',
    text: 'Resolution Center',
    icon: '<i class="fa-sharp-duotone fa-solid fa-screwdriver-wrench"></i>',
    roles: ['SuperAdmin', 'SystemAdmin', 'Admin', 'Reviewer'],
    category: 'main',
    component: ResolutionCenterComponent,
    title: 'CareOregon - DBD - Resolution Center'
  },
  {
    route: '/dcoAdmin',
    text: 'DCO Admin',
    icon: '<i class="fa-sharp-duotone fa-solid fa-database"></i>',
    roles: ['SuperAdmin', 'SystemAdmin'],
    category: 'admin',
    component: DcoAdminComponent,
    title: 'CareOregon - DBD - DCO Admin'
  },
  {
    route: '/formAdmin',
    text: 'Form Admin',
    icon: '<i class="fa-sharp-duotone fa-solid fa-folder-gear"></i>',
    roles: ['*'],
    category: 'admin',
    component: DentalReferralFormComponent,
    title: 'CareOregon - DBD - Form Admin'
  },
  {
    route: '/userAdmin',
    text: 'User Admin',
    icon: '<i class="fa-sharp-duotone fa-solid fa-user-gear"></i>',
    roles: ['SuperAdmin', 'SystemAdmin', 'Admin'],
    category: 'admin',
    component: UserAdminComponent,
    title: 'CareOregon - DBD - User Admin'
  },
  {
    route: '/listAdmin',
    text: 'List Admin',
    icon: '<i class="fa-sharp-duotone fa-solid fa-list-dropdown fa-swap-opacity"></i>',
    roles: ['SuperAdmin', 'SystemAdmin', 'Admin'],
    category: 'admin',
    component: ListAdminComponent,
    title: 'CareOregon - DBD - List Admin'
  },
  {
    route: '/appSettings',
    text: 'App Settings',
    icon: '<i class="fa-sharp-duotone fa-solid fa-square-sliders-vertical"></i>',
    roles: ['SystemAdmin'],
    category: 'admin',
    component: AppSettingsComponent,
    title: 'CareOregon - DBD - App Settings'
  }
];
